import { render, staticRenderFns } from "./AppointmentInfo.vue?vue&type=template&id=4a818cef&scoped=true&"
import script from "./AppointmentInfo.vue?vue&type=script&lang=ts&"
export * from "./AppointmentInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a818cef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-teachers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a818cef')) {
      api.createRecord('4a818cef', component.options)
    } else {
      api.reload('4a818cef', component.options)
    }
    module.hot.accept("./AppointmentInfo.vue?vue&type=template&id=4a818cef&scoped=true&", function () {
      api.rerender('4a818cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schedule/AppointmentInfo.vue"
export default component.exports